export const FORMAT_TEXT = {
	// Gender
	M: 'Male',
	F: 'Female',
	// Status
	A: 'Active',
	I: 'Inactive',
	P: 'Pending',
	// Boolean
	false: 'False',
	true: 'True'
}